import { PrivateAxiosInstance } from "config/axios";
const getAuthToken = () => {
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  return userData?.token;
};

export const API_CREATE_MAIN_LAUNDRY = async (data) => {
  try {    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.post(
      "/main-laundry/create-laundry",
      data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};


export const API_LIST_MAIN_LAUNDRY = async (params) => {
  try {    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.get(
      "/main-laundry/laundries",
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
        params: params, // Include dynamic params
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_DELETE_MAIN_LAUNDRY = async (id) => {
  try {    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.delete(
      `/main-laundry/laundry/${id}`,
      // data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};



export const API_GET_MAIN_LAUNDRY = async (id) => {
  try {    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.get(
      `/main-laundry/laundry/${id}`,
      // data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
export const API_UPDATE_MAIN_LAUNDRY = async (data, id) => {
  try {    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.put(
      `/main-laundry/laundry/${id}`,
      data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
